import {
  hasProductLockAccess,
  PRODUCT_LOCK,
} from "./productLockConfig";

/** Sidebar row key → entitlement key used by hasProductLockAccess. */
export const NAV_ITEM_LOCK_KEY = {
  advisor: "advisor",
  source: "voice_of_customer",
  "sonic-survey": "survey",
  "sonic-prospect": "sonic_prospect",
  survey: "voice_of_customer",
  myDashboards: "voice_of_customer",
  global_executive: "voice_of_customer",
  home: "voice_of_customer",
  journeys: "customer_journey",
  industryTopics: "market_intelligence",
  "customer-365": "customer_365",
  "behavioral-segmentation": "advanced_behavioral_segmentation",
  sonic: "sonic_engage",
  "ai-services/auto-reports": "voice_of_customer",
  report: "voice_of_customer",
};

export const NAV_ITEM_KEYS = Object.keys(NAV_ITEM_LOCK_KEY);

export function getLockedNavKeys(subscriptionRow, extras = {}) {
  return NAV_ITEM_KEYS.filter((navKey) => {
    if (navKey === "advisor" && extras.advisorAccessReady === false) {
      return false;
    }
    const productKey = NAV_ITEM_LOCK_KEY[navKey];
    return !hasProductLockAccess(productKey, subscriptionRow, extras);
  });
}

export function shouldCollapseLockedNav(lockedKeys) {
  const total = NAV_ITEM_KEYS.length;
  if (!total) return false;
  return lockedKeys.length / total > 0.5;
}

export function lockedProductKeysForDiscover(lockedNavKeys) {
  const seen = new Set();
  const keys = [];
  lockedNavKeys.forEach((navKey) => {
    const productKey = NAV_ITEM_LOCK_KEY[navKey];
    if (!productKey || seen.has(productKey) || !PRODUCT_LOCK[productKey]) return;
    seen.add(productKey);
    keys.push(productKey);
  });
  return keys;
}

export function ownedProductKeysForDiscover(subscriptionRow, extras = {}) {
  const seen = new Set();
  const keys = [];
  NAV_ITEM_KEYS.forEach((navKey) => {
    if (navKey === "advisor" && extras.advisorAccessReady === false) return;
    const productKey = NAV_ITEM_LOCK_KEY[navKey];
    if (!productKey || seen.has(productKey) || !PRODUCT_LOCK[productKey]) return;
    if (hasProductLockAccess(productKey, subscriptionRow, extras)) {
      seen.add(productKey);
      keys.push(productKey);
    }
  });
  return keys;
}
